import { AxiosRequestConfig } from 'axios'
import { auth0 } from 'Common/plugins/auth0'

async function authenticationInterceptor(config: AxiosRequestConfig): Promise<AxiosRequestConfig> {
  try {
    const token = await auth0.getAccessTokenSilently()

    config.headers.Authorization = `Bearer ${token}`
  } catch (error) {
    // TODO rethrow error and display error message?
    console.error(error.response.status, error.message)
  }

  return config
}

export { authenticationInterceptor }
